import { render } from "./Sobre.vue?vue&type=template&id=1f0df9c9&scoped=true"
import script from "./Sobre.vue?vue&type=script&lang=ts"
export * from "./Sobre.vue?vue&type=script&lang=ts"

import "./Sobre.vue?vue&type=style&index=0&id=1f0df9c9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1f0df9c9"

export default script